import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import * as lessonSelectors from 'common.components/lesson/selectors';

import { CustomLessonViewHeader } from './custom-lesson-view__header';

import './custom-lesson-view__header.scss';

interface Props {
    controls?: ReactNode;
}

export const CustomLessonViewHeaderContainer = React.memo((props: Props) => {
    const { controls } = props;
    const name = useSelector(lessonSelectors.getName);
    const description = useSelector(lessonSelectors.getDescription);
    const customDescription = useSelector(lessonSelectors.getCustomLessonViewDescription);
    const imageSrc = useSelector(lessonSelectors.getCustomLessonViewImageSrc);
    const tags = useSelector(lessonSelectors.getCustomLessonViewTags);

    return (
        <CustomLessonViewHeader
            controls={controls}
            description={customDescription || description}
            imageSrc={imageSrc}
            name={name}
            tags={tags}
        />
    );
});
